<template>
    <div class="mt-14 text-center">
        <PrimaryButton
            v-if="page < items.meta.last_page"
            :loading="loading"
            @click="loadMore"
            class="sm:w-64 mb-6"
            color="indigo"
        >
            Показати ще
        </PrimaryButton>

        <div class="flex justify-between items-center">
            <div class="flex">
                <div class="w-12">
                    <PrimaryButton @click="toPage(1)" :disabled="page === 1" :loading="loading">
                        <DoubleChevron class="h-5 rotate-180"/>
                    </PrimaryButton>
                </div>
                <div class="w-12 ml-3">
                    <PrimaryButton @click="toPage(page - 1)" :disabled="page === 1" :loading="loading">
                        <Chevron class="rotate-180 h-5"/>
                    </PrimaryButton>
                </div>
            </div>

            <div class="text-gray-600 mx-2">
                Сторінка {{ page }} з {{ items.meta.last_page }}
            </div>

            <div class="flex">
                <div class="w-12">
                    <PrimaryButton @click="toPage(page + 1)"
                                   :disabled="page === items.meta.last_page"
                                   :loading="loading">
                        <Chevron class="h-5"/>
                    </PrimaryButton>
                </div>
                <div class="w-12 ml-3">
                    <PrimaryButton @click="toPage(items.meta.last_page)"
                                   :disabled="page === items.meta.last_page"
                                   :loading="loading">
                        <DoubleChevron class="h-5"/>
                    </PrimaryButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DoubleChevron from "@/Components/Svg/DoubleChevron.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import Chevron from "@/Components/Svg/Chevron.vue";
import {router} from "@inertiajs/vue3";

export default {
    components: {Chevron, PrimaryButton, DoubleChevron},
    props: {
        items: {
            type: Object,
            required: true
        },
        baseUrl: {
            type: String,
            required: true
        },
        modelName: {
            type: String,
            required: true
        },
        onPageLoaded: {
            type: Function,
            required: true
        },
        onMoreLoaded: {
            type: Function,
            required: true
        },
        getAdditionalQueryParams: {
            type: Function,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            page: this.items.meta.current_page,
        }
    },
    methods: {
        loadMore() {
            this.loading = true

            router.visit(this.baseUrl, {
                data: {...this.getAdditionalQueryParams(), page: this.page + 1},
                preserveScroll: true,
                preserveState: true,
                replace: false,
                only: [this.modelName],
                onSuccess: (data) => {
                    const items = data.props[this.modelName]

                    this.page = items.meta.current_page

                    this.onMoreLoaded(items)
                },
                onFinish: () => this.loading = false
            })
        },
        toPage(page) {
            this.loading = true

            router.visit(this.baseUrl, {
                data: {...this.getAdditionalQueryParams(), page},
                only: [this.modelName],
                onSuccess: (data) => {
                    const items = data.props[this.modelName]

                    this.page = items.meta.current_page

                    this.onPageLoaded(items)
                },
                onFinish: () => this.loading = false
            })
        },
    }
}
</script>
